import React from 'react';
import { ACLAuthorizationRequest } from '@/api/bol';
import { LogisticsObjectFormDialog } from '@/components/common/LogisticsObjectFormDialog';
import { defaultPieceTemplate } from '@/utils/pieceDefaultTemplate';

export interface PieceFormDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { memberIdentifier: string; pieceJson: string; aclAuthorizations?: ACLAuthorizationRequest[] }) => Promise<void>;
}

export const PieceFormDialog: React.FC<PieceFormDialogProps> = ({
  open,
  onClose,
  onSubmit,
}) => {
  const handleSubmit = async (data: { memberIdentifier: string; jsonData: string; pieceJson?: string; aclAuthorizations?: ACLAuthorizationRequest[] }) => {
    const transformedData = {
      memberIdentifier: data.memberIdentifier,
      pieceJson: data.pieceJson || data.jsonData,
      aclAuthorizations: data.aclAuthorizations,
    };

    await onSubmit(transformedData);
  };

  return (
    <LogisticsObjectFormDialog
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      title="Create New Piece"
      jsonFieldName="pieceJson"
      defaultJsonTemplate={defaultPieceTemplate()}
      jsonLabel="Enter a valid Piece JSON according to the SDL schema:"
      jsonHelperText="The JSON must conform to the Piece schema defined in the BOL API"
      submitButtonText="Create"
    />
  );
};
